import styled from "styled-components";

export const PageBody = styled.div<{ fullHeight?: boolean }>`
  padding: 20px;
  overflow: auto;
  width: 100%;
  height: ${(p) => (p.fullHeight ? "100%" : "calc(100% - 71px)")};

  @media screen and (max-width: 400px) {
    padding: 10px 5px;
  }
`;

export const FixedContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 30px;

  @media (max-width: 768px) {
    padding: 0 20px;
  }

  @media screen and (max-width: 400px) {
    padding: 0 15px;
  }
`;
